import { useDevice } from 'app/agriculture/queries/devices/useDevice';
import { useEntities } from 'app/agriculture/queries/entities/useEntities';
import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';
import { Position } from 'app/agriculture/queries/types/geometry/Position';

export function useDeviceLocation({ deviceId }: Readonly<{ deviceId: string }>) {
    const { locationOverride, infrastructureId, deviceType } = useDevice({ deviceId });
    const locationSnapshot = useSnapshot({
        snapshotType: 'Location',
        parentId: deviceId,
        shelfLife: null,
    });

    // Currently only tanks can be infrastructure
    const tanks = useEntities('Tank');
    if (infrastructureId !== null && deviceType === 'Level Monitor') {
        const tank = tanks.get(infrastructureId);
        if (tank) {
            return tank.geometry.coordinates;
        }
    }

    const location = locationOverride ?? locationSnapshot?.location ?? null;
    if (location == null) return null;
    const { latitude, longitude } = location;
    const position: Position = [longitude, latitude];
    return position;
}
